module.exports = __webpack_public_path__ + "img/xenoblade-chronicles.7d841a9a.png";